import React from "react";
import {OptiselEventJson} from "./OptiselEventHistoryPage";
import {OptiselEventTags} from "./optiselEventTags";

export function OptiselEventSummarization({event}: { event: OptiselEventJson }) {
    const badges = event.technicalTags
        .map(tag => renderTagBadge(tag))
        .filter((badge): badge is JSX.Element => badge !== null);

    if (badges.length === 0) {
        return null;
    }
    return <div className={"mt-1 d-flex flex-wrap gap-1"}>
        {badges.map((badge, index) => <React.Fragment key={index}>{badge}</React.Fragment>)}
    </div>;
}

function renderTagBadge(tag: string): JSX.Element | null {
    if (tag === OptiselEventTags.WYMIARY_ZATWIERDZONE) {
        return <span className={"badge badge-light-success"}>Wymiary zatwierdzone</span>;
    }
    if (tag === OptiselEventTags.WYMIARY_NIEZATWIERDZONE) {
        return <span className={"badge badge-light-warning"}>Wymiary niezatwierdzone</span>;
    }
    if (tag === OptiselEventTags.BRAK_MECHANIKI) {
        return <span className={"badge badge-danger fs-7"}><i className="fas fa-exclamation-triangle me-1"></i>Brak mechaniki</span>;
    }
    return null;
}
